import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type {
  AnnouncementDetails,
  CreateAnnouncementPayload,
} from '../model/types';

export const createAnnouncementAPI = async (
  payload: CreateAnnouncementPayload,
) => {
  const response = await baseAPI.post<AnnouncementDetails>(
    '/announcements',
    payload,
  );
  return response.data;
};

export const useCreateAnnouncementMutation = () => {
  return useMutation({
    mutationFn: createAnnouncementAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ANNOUNCEMENTS],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        error.response?.data?.message ?? 'Failed to create announcement',
      );
    },
  });
};
